import * as React from 'react';
import { ListItemIcon, ListItemText } from '@mui/material';
import { BaseDynamic, CrawlContext, NormalizeStateContext, ExtendFieldContext } from '../HoForm';
import { Folder } from '@mui/icons-material';
import { hasValidationErrorInTree2 } from '../HoForm/utils';

import ListItemButton from "@mui/material/ListItemButton";

type NestDynamicField  = {
    key: string,
    type: string,
    title:string,
    fields:Array<any>,
    groupdata?: boolean
};

class NestDynamic extends BaseDynamic<NestDynamicField, {}> {

    allocateStateLevel(field : NestDynamicField, parentState : any, rootState : any){
        if(field.groupdata==null||field.groupdata===true){
            if(parentState[field.key] ==null || typeof(parentState[field.key])!=='object' || Array.isArray(parentState[field.key])){
                parentState[field.key]={};
            }
            return parentState[field.key];
        }
        return parentState;
    }

    normalizeState({state, field, stateBuilder} : NormalizeStateContext<NestDynamicField>){
        stateBuilder.setLevelState(state, field.fields);
    }

    extendField({field, extender} : ExtendFieldContext<NestDynamicField>): void{  
        if(field.groupdata==null) field.groupdata = true;
        extender.extendFields(field.fields);
    }

    getType(){
        return 'nest';
    }

    buildBreadcumbFragment(node : any, buttons : Array<{label:string, node:any}>){
        buttons.push({label: node.field.title, node});
    }

    buildDisplayPathFragment(node : any){
        if(node.field.groupdata===false){
            return `${node.field.key}`;
        }
        return node.field.key;
    }

    crawlComponent({form, node} : CrawlContext<NestDynamicField>): void{
        const { field, state } = node;
        form.crawlLevel({fields: field.fields, state, parent:node});
    }

    renderComponent(){      
        let {context} = this.props;
        let {node, currentPath, nodePath, parentPath} = context;
        let {field} = node;
       
        if(currentPath===parentPath){
            const hasErrors = hasValidationErrorInTree2(node.state, nodePath);

            return (
                <ListItemButton
                    style={{border: 'solid 1px #eee', margin: '3px 0'}}
                    onClick={function(){ context.setPath(node) } }>
                    <ListItemText
                        primary={field.title}
                        slotProps={{
                            primary: {color:hasErrors?"error":undefined}
                        }} />
                    <ListItemIcon><Folder /></ListItemIcon>
                </ListItemButton>
            );
        }
        
        if(currentPath.startsWith(nodePath)){
            var state = node.state;
            return context.form.renderLevel({ fields: field.fields, state, parent: node });
        }

        return (null);
    }
}

export default NestDynamic;
